import { render, staticRenderFns } from "./CourseNewUser.html?vue&type=template&id=3f4ce38c&scoped=true&external"
import script from "./CourseNewUser.vue?vue&type=script&lang=js"
export * from "./CourseNewUser.vue?vue&type=script&lang=js"
import style0 from "./CourseNewUser.scss?vue&type=style&index=0&id=3f4ce38c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4ce38c",
  null
  
)

export default component.exports